/**
 * TaskEmitter — 태스크 카드 생성 이벤트 중개
 *
 * MessagePopover → TaskCreateModal 연결.
 * MemoModalEmitter 패턴과 동일.
 */
import EventEmitter from 'eventemitter3';

export const TaskEmitter = new EventEmitter();
/** @deprecated InsightEmitter → TaskEmitter */
export const InsightEmitter = TaskEmitter;

/**
 * 이벤트 시그니처:
 * - 'create' (threadText: string, roomId: string, threadMessageId: string)
 *   → TaskCreateModal 열기
 * - 'created' (roomId: string, postId?: string)
 *   → 카드 생성 완료 → TasksInlineView 목록 갱신
 *   → postId 있으면 분할 뷰로 해당 태스크 자동 표시
 * - 'open' (roomId: string, postId: string)
 *   → 시스템 메시지/외부에서 특정 태스크를 열 때 사용
 */
